<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label [innerHtml]="question?.question_copy || question?.email_version"></label>
  }
  <div class="custom-number">
    @for (item of items; track item; let i = $index) {
      <label class="custom-number__number">
        <input type="radio" [attr.tabindex]="i + 1" [id]="uniqueControlName" class="answers" (click)="onRadioCheck(item.answer)"
          [checked]="item.answer === question?.answer">
          <span class="custom-number__label">
            {{item.answer}}
            <span></span>
          </span>
        </label>
      }
    </div>
  </div>
